<p-menu #menu [popup]="true" [model]="userMenus.menu$ | async | mit: 'user-menu' | async" appendTo="body"></p-menu>
<button
  pButton
  type="button"
  icon="fa fa-fw fa-user"
  iconPos="right"
  [label]="firstName$ | async"
  (click)="menu.toggle($event)"
  class="p-button-text p-button-rounded"
></button>
